// extracted by mini-css-extract-plugin
module.exports = {"money":"Money_money__20p7P","name":"Money_name__hcnOk","btnBalance":"Money_btnBalance__2Z0Cc","footerBalance":"Money_footerBalance__26x5U","saldo":"Money_saldo__3lV_X"};